<section
  class="mobile-parent-categories-navigation"
  *ngIf="isTopCategoryView"
  [@categoryListAnimation]="isTopCategoryView"
>
  <div class="menu-list-container">
    <h3
      class="menu-list-container__title"
      [ngClass]="{ 'menu-list-container__title-v2': isNewMenuBarEnabledV2 | async }"
    >
      {{ 'HOME.HOME_PAGE.PROMO_CATEGORIES.PARENT_CATEGORY_TITLE' | translate }}
    </h3>

    <ul class="menu-list">
      <li class="menu-list__item">
        <mm-icon class="icon" [name]="'all-promotions'"></mm-icon>
        <a
          [routerLink]="(isAllOffersFFEnabled$ | async) ? allOffersRoute : ['/catalog']"
          [queryParams]="!(isAllOffersFFEnabled$ | async) && { 'f.promotion': true }"
          fxLayoutAlign="flex-start center"
          (click)="fireAllPromotionsClickEvent(); fireCategoryNavigationGAEvent(promoCategory)"
        >
          {{ 'HOME.HOME_PAGE.HEADER.CATEGORIES.ALL_OFFERS' | translate }}
        </a>
      </li>
      <li class="menu-list__item" *ngIf="topMenuPromotionLink">
        <mm-icon class="icon" [name]="'coupon'" [isCurrentColor]="false"></mm-icon>
        <a
          [attr.data-category-id]="topMenuPromotionLink?.id"
          [mmTestTarget]="'selected-category-link'"
          (click)="fireCategoryNavigationGAEvent(topMenuPromotionLink); navigateToTopMenuPromotionLink()"
          fxLayoutAlign="flex-start center"
        >
          {{ topMenuPromotionLink?.name }}
        </a>
      </li>
      <li class="menu-list__item" *ngIf="topMenuPromotionLink && !(isNewMenuBarEnabledV2 | async)">
        <mm-icon class="icon" [name]="'buy-again'" [isCurrentColor]="false"></mm-icon>
        <a
          [routerLink]="user ? buyAgainLink : validateEmailLink"
          [queryParams]="user ? {} : { backUrl: buyAgainLink }"
          [mmTestTarget]="'navigation-buy-again'"
          type="button"
          (click)="fireBuyAgainGAEvent()"
        >
          {{ 'HEADER.ALL_PAGES.HEADER.BUY_AGAIN_BUTTON' | translate }}
        </a>
      </li>
    </ul>
  </div>
  <div class="horizontal-divider"></div>

  <div class="menu-list-container">
    <h3
      class="menu-list-container__title"
      [ngClass]="{ 'menu-list-container__title-v2': isNewMenuBarEnabledV2 | async }"
    >
      {{ 'HOME.HOME_PAGE.TOP_CATEGORIES.CONTAINER_SUB_TITLE' | translate }}
      {{ 'HOME.HOME_PAGE.TOP_CATEGORIES.CONTAINER_TITLE' | translate }}
    </h3>

    <ul class="menu-list">
      <li class="menu-list__item" *ngFor="let category of categories">
        <mm-icon
          class="icon"
          [name]="categoryIcons[category.id] || defaultIcon"
          [isCurrentColor]="!categoryIcons[category.id]"
        ></mm-icon>
        <a
          [attr.data-category-id]="category?.id"
          [mmTestTarget]="'selected-category-link'"
          (click)="fireCategoryNavigationGAEvent(category); navigateToSubCategories(category)"
          fxLayoutAlign="flex-start center"
        >
          {{ category?.name }}
        </a>
      </li>
    </ul>
  </div>

  <ng-container *ngIf="!(isNewMenuBarEnabledV2 | async)">
    <div class="spacer"></div>
    <div class="region-selector-price-container">
      <app-region-selector *ngIf="regionSelector$ | async" [mobileSidenavMenu]="true"></app-region-selector>
      <div class="horizontal-divider"></div>
      <div class="price-switch-container">
        <app-price-switch [mobileMenuShown]="true" [mobileSidenavMenu]="true" [inputId]="'price-switch-input-mobile-v1'">
        </app-price-switch>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isNewMenuBarEnabledV2 | async">
    <div class="horizontal-divider"></div>
    <div class="menu-list-container">
      <h3 class="menu-list-container__title-v2">
        {{ 'PURCHASES_GROUP_TITLE' | translate }}
      </h3>

      <ul class="menu-list">
        <li *ngIf="!showApprovalDashboard && !(isShowingOrdersHistoryLink$ | async)" class="menu-list__item">
          <app-svg-re-buy class="icon"></app-svg-re-buy>
          <span fxLayoutAlign="flex-start center" (click)="onBuyAgainLinkClick()">
            <p>{{ 'BUY_AGAIN_NAV_TITLE' | translate }}</p>
          </span>
        </li>

        <li *ngIf="(!showApprovalDashboard) && (isShowingOrdersHistoryLink$ | async)" class="menu-list__item">
          <app-svg-box class="icon"></app-svg-box>
          <span fxLayoutAlign="flex-start center" (click)="onOrdershistoryLinkClick()">
            <p>{{ 'ORDERS_HISTORY_NAV_TITLE' | translate }}</p>
          </span>
        </li>

        <li *ngIf="showApprovalDashboard && (isApprovalDashboardFFEnabled$ | async)" class="menu-list__item">
          <app-svg-approvals class="icon"></app-svg-approvals>
          <span fxLayoutAlign="flex-start center" (click)="onApprovalDashboardLinkClick()">
            <p>{{ 'APPROVALS_NAV_TITLE' | translate }}</p>
          </span>
        </li>


        <ng-container *ngIf="isMultipleShoppingListEnabled | async; else defaultShoppingList">
          <li class="menu-list__item">
            <app-svg-list class="icon" idSuffix='multiple-shopping-list-mobile'></app-svg-list>
            <span fxLayoutAlign="flex-start center" (click)="onShoppingListClick(true)">
              <p>{{ 'SHOPPING_LIST_NAV_TITLE' | translate }}</p>
            </span>
          </li>
        </ng-container>
        <ng-template #defaultShoppingList>
          <li class="menu-list__item">
            <app-svg-list idSuffix="default-shopping-list-mobile" class="icon"></app-svg-list>
            <span fxLayoutAlign="flex-start center" (click)="onShoppingListClick()">
              <p>{{ 'SHOPPING_LIST_NAV_TITLE' | translate }}</p>
            </span>
          </li>
        </ng-template>
      </ul>
    </div>
    <div class="horizontal-divider"></div>
    <div class="region-selector-price-container">
      <app-region-selector *ngIf="regionSelector$ | async" [mobileSidenavMenu]="true"></app-region-selector>
      <div class="price-switch-container-v2">
        <app-price-switch [mobileMenuShown]="true" [mobileSidenavMenu]="true" [inputId]="'price-switch-input-mobile-v2'">
        </app-price-switch>
      </div>
    </div>
    <div class="horizontal-divider"></div>
  </ng-container>
</section>

<section
  [@childCategoryListAnimation]="!isTopCategoryView"
  *ngIf="!isTopCategoryView"
  class="mobile-children-categories-navigation"
>
  <div class="mobile-children-categories-navigation__header bordered" [mmTestTarget]="'mobile-categories-back-button'">
    <div
      class="mobile-children-categories-navigation__header__back"
      (click)="backToTopCategories()"
      *ngIf="selectedCategory?.id !== promoCategory?.id"
    >
      <mm-icon name="chevron-left"></mm-icon>
      <span>{{ 'CHECKOUT.STEPPER.BACK' | translate }}</span>
    </div>
    <div
      class="mobile-children-categories-navigation__header__category-title"
      (click)="navigateToCategory(selectedCategory)"
    >
      {{ 'HEADER.ALL_PAGES.HEADER.CATEGORIES.SHOW_ALL' | translate }} {{ selectedCategory?.name }}
    </div>
  </div>
  <div class="mobile-children-categories-navigation__bubble-wrapper">
    <app-category-bubble
      class="bubble-width"
      *ngFor="let childrenCategory of selectedCategory?.children"
      [category]="childrenCategory"
      [isInNavigationMenu]="true"
    ></app-category-bubble>
  </div>
</section>
<!-- this component adds a hidden list of subcategory links from the menu to the html so they can be crawled -->
<app-crawlable-categories [categories]="childCategories"></app-crawlable-categories>
